export const RESET = 'EXCMDAILYPLAN_UPDATE_RESET'
export const SET_ERROR = 'EXCMDAILYPLAN_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMDAILYPLAN_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMDAILYPLAN_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMDAILYPLAN_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMDAILYPLAN_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMDAILYPLAN_UPDATE_UPDATE_RETRIEVED'
